import "./expand-tags.scss";

$(document).ready(function () {
  var tagsContaineWrap = $(".expand-tags");
  var tagsContainer = $(".expand-tags .tags");
  var expandBtn = $(".expand-tags-button");

  function toggleExpandButton() {
    if (tagsContainer[0].scrollHeight === 40) {
      tagsContainer.removeAttr("style");
      expandBtn.removeClass("show");
    }
    if (tagsContainer[0].scrollHeight > tagsContainer.innerHeight()) {
      expandBtn.addClass("show").addClass("closed");
    } else if (tagsContainer.css("max-height") !== "40px") {
      expandBtn.addClass("show").removeClass("closed");
    } else {
      expandBtn.removeClass("show");
    }
  }
  if (tagsContaineWrap.length > 0) {
    expandBtn.on("click", function () {
      if (expandBtn.hasClass("closed")) {
        tagsContainer.css("max-height", tagsContainer[0].scrollHeight + "px");
        expandBtn.removeClass("closed");
      } else {
        tagsContainer.css("max-height", "40px");
        expandBtn.addClass("closed");
      }
    });

    toggleExpandButton();

    $(window).on("resize", function () {
      toggleExpandButton();
    });
  }
});
